// src/components/CopyButton.js
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Clipboard, CheckCircleFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

/**
 * Компонент кнопки копирования с анимацией подтверждения
 * @param {string} text - Текст, который нужно скопировать
 * @param {string} className - Дополнительные классы CSS (опционально)
 */
const CopyButton = ({ text, className = "" }) => {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();

    const handleCopy = () => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => {
                console.error('Could not copy text: ', err);
            });
    };

    return (
        <Button
            variant="link"
            className={`copy-button ${className}`}
            onClick={handleCopy}
            title={t('common.copy')}
        >
            {copied ? (
                <CheckCircleFill className="text-success" />
            ) : (
                <Clipboard />
            )}
        </Button>
    );
};

export default CopyButton;